// DASHBOARD
export const ORDER_FETCH = 'ORDER_FETCH'
export const ORDER_RESPONSE = 'ORDER_RESPONSE'
export const DASHBOARD_FETCH = 'DASHBOARD_FETCH'
export const WARRANTIES_OVER_TIME_RESPONSE = 'WARRANTIES_OVER_TIME_RESPONSE'
export const UPDATE_ORDER_SOURCE = 'UPDATE_ORDER_SOURCE'

// ORDER DETAILS
export const ORDER_DETAIL_FETCH = 'ORDER_DETAIL_FETCH'
export const ORDER_DETAIL_RESPONSE = 'ORDER_DETAIL_RESPONSE'
export const ORDER_DETAIL_CANCEL = 'ORDER_DETAIL_CANCEL'
export const UPDATE_SEARCH_STRING = 'UPDATE_SEARCH_STRING'

// RETAILERS FETCH
export const RETAILERS_FETCH_START = 'RETAILERS_FETCH_START'
export const RETAILERS_FETCH_SUCCESS = 'RETAILERS_FETCH_SUCCESS'
export const RETAILERS_FETCH_FAIL = 'RETAILERS_FETCH_FAIL'
export const UPDATE_SELECTED_RETAILER = 'UPDATE_SELECTED_RETAILER'

// PRICING OVERRIDES FETCH
export const FETCH_PRICING_OVERRIDES_REQUEST = 'FETCH_PRICING_OVERRIDES_REQUEST'
export const FETCH_PRICING_OVERRIDES_SUCCESS = 'FETCH_PRICING_OVERRIDES_SUCCESS'
export const FETCH_PRICING_OVERRIDES_ERROR = 'FETCH_PRICING_OVERRIDES_ERROR'

// PRICING OVERRIDES UPDATE
export const UPDATE_PRICING_OVERRIDES_SUCCESS =
  'UPDATE_PRICING_OVERRIDES_SUCCESS'
export const UPDATE_PRICING_OVERRIDES_ERROR = 'UPDATE_PRICING_OVERRIDES_ERROR'

// WARRANTY CLAIMS FETCH
export const FETCH_WARRANTY_CLAIMS_REQUEST = 'FETCH_WARRANTY_CLAIMS_REQUEST'
export const FETCH_WARRANTY_CLAIMS_SUCCESS = 'FETCH_WARRANTY_CLAIMS_SUCCESS'
export const FETCH_WARRANTY_CLAIMS_ERROR = 'FETCH_WARRANTY_CLAIMS_ERROR'
export const FETCH_ALL_WARRANTY_STATUSES_REQUEST =
  'FETCH_ALL_WARRANTY_STATUSES_REQUEST'

// WARRANTY CLAIM DETAILS
export const SET_WARRANTY_CLAIM_DETAILS = 'SET_WARRANTY_CLAIM_DETAILS'
export const FETCH_WARRANTY_CLAIM_BY_ID_REQUEST =
  'FETCH_WARRANTY_CLAIM_BY_ID_REQUEST'
export const FETCH_WARRANTY_CLAIM_BY_ID = 'FETCH_WARRANTY_CLAIM_BY_ID'
export const FETCH_WARRANTY_CLAIM_BY_ID_ERROR =
  'FETCH_WARRANTY_CLAIM_BY_ID_ERROR'
export const UPDATE_WARRANTY_CLAIM_BY_ID = 'UPDATE_WARRANTY_CLAIM_BY_ID'
export const UPLOAD_ATTACHMENTS_BY_ID_REQUEST =
  'UPLOAD_ATTACHMENTS_BY_ID_REQUEST'
export const UPLOAD_ATTACHMENTS_BY_ID_SUCCESS =
  'UPLOAD_ATTACHMENTS_BY_ID_SUCCESS'
export const UPDATE_SHIPPING_ADDRESS_BY_ID_REQUEST =
  'UPDATE_SHIPPING_ADDRESS_BY_ID_REQUEST'

// Pricing control
export const FETCH_TAXONOMY_REQUEST = 'FETCH_TAXONOMY_REQUEST'
